// extracted by mini-css-extract-plugin
module.exports = {"button":"service-module--button--1ZWDC","circle":"service-module--circle--2sL58","title":"service-module--title--2_jZm"};